import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationDetailsTmamsConstants {
    static STEP_TITLE = "Details";
    static SAVE_BUTTON_PLACEHOLDER = SharedConstants.SAVE_LABEL;
    static DESCRIPTION_LABEL = "Description";
    static APPLICATION_TYPE_LABEL = "Application type";
    static REFERENCE_NUMBER_LABEL = "Reference number";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "type";
    static REFERENCE_NUMBER_CONTROL_NAME = "referenceN" +
        "umber";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        type: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        referenceNumber: {
            required: `Reference number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
